import { Component, OnInit, Input, TemplateRef, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
	selector: "app-edit-header",
	templateUrl: "./edit-header.component.html",
	styleUrls: ["./edit-header.component.scss"],
})
export class EditHeaderComponent implements OnInit {
	@Input() title: string;
	@Input() subtitle: string;
	@Input() cancelRoute: any[];
	@Input() cancelFn: () => any;
	@Input() cancelLabel: string;
	@Input() cancelTooltip: string;
	@Input() cancelTemplateRef: TemplateRef<any>;
	@Input() buttonTemplateRef: TemplateRef<any>;
	@Input() titleTemplateRef: TemplateRef<any>;
	@Input() headerClass: string;
	@Input() containerClass: string;
	@Input() rowClass: string;
	@Input() titleClass: string;
	@Input() buttonClass: string;
	@Input() cancelAccessKey: string;
	@HostListener("document:keydown.escape", ["$event"]) onKeydownHandler(event: KeyboardEvent) {
		event.stopPropagation();
		this.cancel();
	}

	constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

	ngOnInit(): void {
		this.cancelLabel = this.cancelLabel || "cancel";
		this.cancelTooltip = this.cancelTooltip || "Cancel";
		this.cancelFn = this.cancelFn || this.defaultCancelFn;
		this.cancelAccessKey = this.cancelAccessKey || "x";

		this.headerClass = this.headerClass || "bg-light text-primary";
		this.containerClass = this.containerClass || "container-md";
		this.rowClass = this.rowClass || "row py-3";
		this.titleClass = this.titleClass || "m-1 align-self-center";
		this.buttonClass =
			this.buttonClass || "col-12 col-md-2 mt-3 mt-md-0 text-end d-flex justify-content-end";
	}

	cancel(): void {
		!!this.cancelFn ? this.cancelFn() : this.defaultCancelFn();
	}

	private defaultCancelFn = () => {
		this.router.navigate(this.cancelRoute || ["/"], { relativeTo: this.activatedRoute });
	};
}
